import { ARTran, PaymentUi } from '@aiwyn/api';
import { DateService } from '@aiwyn/shared';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PaymentDateService {

  constructor() { }

  /**
   * Format PaymentUi to local time zone
   * @param paymentUi UTC paymentUi object
   * return local date time PaymentUi
   */
  static formatLocalDateTimePayment(paymentUi: PaymentUi): PaymentUi {
    return {
      ...paymentUi,
      client: {
        ...paymentUi.client,
        createdAt: DateService.getLocalTime(paymentUi.client.createdAt),
        updatedAt: DateService.getLocalTime(paymentUi.client.updatedAt),
      },
      payment: {
        ...paymentUi.payment,
        createdAt: DateService.getLocalTime(paymentUi.payment.createdAt),
        updatedAt: DateService.getLocalTime(paymentUi.payment.updatedAt),
        arTran: PaymentDateService.getArTranLocalTimes(paymentUi.payment.arTran),
      },
      invoices: paymentUi.invoices.map(invoice => ({
        ...invoice,
        dueDate: DateService.getLocalTime(invoice.dueDate),
        arTran: PaymentDateService.getArTranLocalTimes(invoice.arTran),
      })),
    };
  }

  static getArTranLocalTimes(arTran: ARTran): ARTran {
    arTran.transactionDate = DateService.getLocalTime(arTran.transactionDate);
    arTran.createdAt = DateService.getLocalTime(arTran.createdAt);
    arTran.updatedAt = DateService.getLocalTime(arTran.updatedAt);
    return arTran;
  }
}
